import { DealerCodesDeleteModal } from "./delete";
import { DealerCodesAddDealerToCodeModal } from "./add-dealer-to-code";
import { DealerCodesEditModal } from "./edit";
import type { DealerCode } from "@dealer-center/ddc-api-account-interface";
import { DealerCodesAddCodeToDealerModal } from "./add-code-to-dealer";
import { useState } from "react";
import type {
  dealerCodeMappingDeleteModalInterface,
  dealerCodeMappingEditModalInterface
} from "./helper";

export const useDealerCodeModals = () => {
  const [modal, setModal] = useState<React.ReactElement>(<></>);
  const showDeleteModal = (values: dealerCodeMappingDeleteModalInterface) => {
    setModal(
      <DealerCodesDeleteModal
        close={() => setModal(<></>)}
        show={true}
        values={values}
      />
    );
  };
  const showAddDealerToCodeModal = (accountId: string) => {
    setModal(
      <DealerCodesAddDealerToCodeModal
        accountId={accountId}
        close={() => setModal(<></>)}
        show={true}
      />
    );
  };
  const showAddCodeToDealerModal = (dealerCode: DealerCode) => {
    setModal(
      <DealerCodesAddCodeToDealerModal
        close={() => setModal(<></>)}
        dealerCode={dealerCode}
        show={true}
      />
    );
  };
  const showEditModal = (values: dealerCodeMappingEditModalInterface) => {
    setModal(
      <DealerCodesEditModal
        close={() => setModal(<></>)}
        show={true}
        values={values}
      />
    );
  };
  return {
    showDeleteModal,
    showAddDealerToCodeModal,
    showAddCodeToDealerModal,
    showEditModal,
    modal
  };
};
